import { FC, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { handleCompanyUrl } from 'utils/organizationUtils';

const AppAuth: FC = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const {
    AppStore: { googleAuthConnected },
    notificationStore: { openNotification },
  } = useStore();

  useEffect(() => {
    if (location.search) {
      googleRequest.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const googleRequest = useMutation(() => googleAuthConnected(location.search), {
    onSuccess: (data: any) => {
      if (data && data.data?.success) {
        const token = data.data.bearer_token;
        const hostName = data.data?.domain || data.domain;
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        const authToken = token || localStorage.getItem('token')?.replace('Bearer ', '');
        if (hostName && !hostname.startsWith(`${hostName}.`)) {
          const isLocalhost = hostname.includes('localhost');
          let baseHost;
          if (isLocalhost) {
            baseHost = `localhost${port ? ':' + port : ''}`;
          } else {
            const parts = hostname.split('.');
            baseHost = parts.length === 2 ? hostname : parts.slice(1).join('.');
          }
          window.location.href = `${protocol}//${hostName}.${baseHost}/apps/google?token=${authToken}`;
        } else {
          const redirectUrl = handleCompanyUrl('/apps/google');
          history.push(redirectUrl);
        }
      } else {
        const redirectUrl = handleCompanyUrl('/dashboard');
        history.push(redirectUrl);
      }
    },
    onError: ({ message }: Error) => {
      console.error('Google app auth error:', message);
      openNotification('error', message);
      history.push(handleCompanyUrl('/apps'));
    },
  });

  useAppPreloader(googleRequest.isLoading);

  return <></>;
});

export default AppAuth;
